import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as DTOS from "../FeralScan.dtos";

export const serviceApi = {
    searchUsers: (userId: number, text: string, includeObsolete: boolean) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminGetUsers();
        request.searchText = text;
        request.includeObsolete = includeObsolete;
        request.userId = userId;

        const promise = client.get(request);
        return Observable.from(promise);
    },
    searchUserGroups: (text: string) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminGetUserGroups();
        request.searchText = text;
        request.product = process.env.PRODUCT;

        const promise = client.get(request);
        return Observable.from(promise);
    },
    searchPlots: (plotId: number, searchText: string, includeObsolete: boolean) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminSearchPlots();
        request.searchText = searchText;
        request.includeObsolete = includeObsolete;
        request.plotId = plotId;

        const promise = client.get(request);
        return Observable.from(promise);
    },
    searchFiles: (fileId: number, searchText: string) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminSearchFiles();
        request.searchText = searchText;
        request.fileId = fileId;

        const promise = client.get(request);
        return Observable.from(promise);
    },
    getPlotMetaInfo: () => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminGetPlotMetaInfo();

        const promise = client.get(request);
        return Observable.from(promise);
    },
    editUser: (user: DTOS.User) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminSaveUser();
        request.user = user;

        const promise = client.put(request);
        return Observable.from(promise);
    },
    editUserGroup: (group: DTOS.UserGroup) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminSaveUserGroup();
        request.group = group;
        request.product = process.env.PRODUCT;

        const promise = client.put(request);
        return Observable.from(promise);
    },
    addMemberToUserGroup: (groupId: number, email: string, name: string) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminAddUserToGroup();
        request.email = email;
        request.groupId = groupId;
        request.name = name;
        request.product = process.env.PRODUCT;

        const promise = client.put(request);
        return Observable.from(promise);
    },
    deleteMemberFromUserGroup: (groupId: number, userId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminDeleteUserFromGroup();
        request.userId = userId;
        request.groupId = groupId;
        request.product = process.env.PRODUCT;

        const promise = client.put(request);
        return Observable.from(promise);
    },
    approveMemberForUserGroup: (groupId: number, userId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminApproveUserForGroup();
        request.userId = userId;
        request.groupId = groupId;
        request.product = process.env.PRODUCT;

        const promise = client.put(request);
        return Observable.from(promise);
    },
    updateAdminMemberForUserGroup: (groupId: number, userId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminUpdateAdminUserGroup();
        request.userId = userId;
        request.groupId = groupId;
        request.product = process.env.PRODUCT;

        const promise = client.put(request);
        return Observable.from(promise);
    },
    batchAdminImportPlotEvents: (files: File[], plotId?: number, userId?: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminBatchImportPlotEvents();

        let formData = new FormData();
        files.forEach(file => {
            formData.append('description', file.name);
            formData.append('type', 'file');
            formData.append('file', file);
        });

        if(plotId)
            formData.append('plotId', `${plotId}`);

        if(userId)
            formData.append('userId', `${userId}`);

        const promise = client.postBody(request, formData);
        return Observable.from(promise);
    },
    searchUserRoles: (userId: number, plotId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.AdminSearchUserRoles();
        request.userId = userId;
        request.plotId = plotId;

        const promise = client.get(request);
        return Observable.from(promise);
    },
};
